import { RootState } from '@reducers';

export const selectAbaPayway = (state: RootState) => state.abaPaywayReducer;
